"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WEB_SOCKET_PORT = void 0;
exports.DEFAULT_WEB_SOCKET_PORT = 9999;
